// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__jjojq","right":"Footer_right__3zcJH","buttons":"Footer_buttons__3qz4H"};